import React, { FC } from "react";
import { PageTitle, PageLink } from "../../../../rbts/layout/core";
import { View } from "./components/View";

const widgetsBreadCrumbs: Array<PageLink> = [];

const SupplierAgreementsPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={widgetsBreadCrumbs}>Proveedor</PageTitle>
      <View />
    </>
  );
};

export { SupplierAgreementsPage };
